class DigitalPayPaymentInstrumentsService {
    constructor($q, Restangular) {
        this.$q = $q;
        this.api = Restangular.one('Checkout/DigitalPay');
    }

    initializeCreditCardIframe() {
        return this.api.one('InitializeCreditCardIframe').post();
    }

    listDigitalPayInstruments(isForPaymentAgreement = false) {
        return this.api.one('Instruments').get({ IsForPaymentAgreement: isForPaymentAgreement });
    }

    deleteDigitalPayInstrument(data) {
        return this.api.post('Instruments/Delete', data);
    }

    getUnsavedGiftCardBalances(unsavedGiftCards) {
        return this.api.post('UnsavedGiftCard/Balance', unsavedGiftCards);
    }

    tokenizeGiftCard(cardNumber, pinCode, save) {
        return this.api.post('GiftCard/Tokenize', { cardNumber, pinCode, save });
    }
}

module.exports = DigitalPayPaymentInstrumentsService;



// WEBPACK FOOTER //
// ./src/wallet/digital-pay-payment-instruments.service.js